import BaseService from './BaseService'
import api from './api'
import service from '.'
import { toast } from '../util/decorators'

export default class MovieService extends BaseService {
  constructor() {
    super({
      bookshelf: [],
      bookshelfPage: 0,
      bookshelfPageSize: 48,
      searchQuery: '',
      movie: {
        zs: {}
      }
    })
  }

  get bookshelf() {
    return this.data.bookshelf
  }

  get searchQuery() {
    return this.data.searchQuery
  }

  set searchQuery(value) {
    this.data.searchQuery = value
  }

  get movie() {
    return this.data.movie
  }

  clearBookShelf() {
    this.data.bookshelf = []
    this.data.bookshelfPage = 0
  }

  clearMovie() {
    this.data.movie = {}
  }

  @toast('搜索影片失败')
  async searchBookShelf() {
    await this.loadBookShelf({ kw: this.searchQuery })
  }

  @toast()
  async loadBookShelfByRecommendation(value) {
    if (value === 2) {
      await this.loadBookShelf({ order: 0 })
    } else {
      await this.loadBookShelf({ recmd: value })
    }
  }

  @toast()
  async loadBookShelfByCategory(catid) {
    await this.loadBookShelf({ catid })
  }

  @toast()
  async loadBookShelfByBible(bid) {
    await this.loadBookShelf({ bible_id: bid })
  }

  async loadBookShelf(params) {
    let body = await api.movie.getPage(Object.assign(params, {
      page: this.data.bookshelfPage + 1,
      pagesize: this.data.bookshelfPageSize
    }))
    if (!params.kw || params.kw === this.searchQuery) {
      if (this.data.bookshelfPage === 0) {
        this.data.bookshelf = body.data
      } else {
        this.data.bookshelf = [...this.data.bookshelf, ...body.data]
      }
      if (body.data.length > 0) {
        this.data.bookshelfPage++
      }
    }
  }

  @toast()
  async loadMovie(movid) {
    this.data.movie = await api.movie.getDetail({ movid })
  }

  @toast()
  async getUrl(urlid, movid) {
    let body = await api.movie.getResource({ urlid, movid, token: service.user._token })
    body.url_1 = encodeURI(body.url_1)
    body.url_2 = encodeURI(body.url_2)
    body.url_5 = encodeURI(body.url_5)
    body.url_6 = encodeURI(body.url_6)
    return body
  }

  @toast()
  async loadLatest() {
    return await api.movie.getTops()
  }
}



// WEBPACK FOOTER //
// ./src/service/MovieService.js